import type { PrescriptionGapPolicy } from 'types/prescription';

export const BOUNDARY_NAME_PREFIX = 'Prescription upload';

export const BOUNDARY_TYPE_APPLY = 'APPLY';

export const GEOMETRY_TYPE_POLYGON = 'POLYGON';

export const GEOMETRY_JSON_TYPE_POLYGON = 'Polygon';

export const DEFAULT_GAP_POLICY: PrescriptionGapPolicy = 'MASK';

export const DEFAULT_RATE_UNIT = 'gal/ac';
